export default __webpack_public_path__ + "static/media/icon_delete_pink.b6410e89.svg";